import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { Dialog } from '../prime';
import API from '../../services/api';
import { EntidadesImportables } from '.';
import { IPagination } from '../grid';
import { IPaginatedResponse } from '../../services/model';
import { ImportacionDTO } from '../../services/api/importador/model/importer.model';
import Alert from '../alerts';
import { Grid, GridComponent, Loader } from '..';
import Question from '../question';

const DiccionaryKey = 'components/importer/listado';
const format = (window as any).format;

interface IProps {
  storage?: IDataStorage;

  /** Entidad que se está importando */
  entity?: EntidadesImportables;

  /** información extra para el proceso */
  extraData?: any;

  /** muestra u oculta el importador */
  visible?: boolean;

  onHide: () => void;
}

interface IState {
  storage?: IDataStorage;

  entity?: EntidadesImportables;

  extraData?: any;

  visible?: boolean;

  rollback?: {
    loading?: boolean;
    result?: any;
  }

  question?: ImportacionDTO;
}

class Index extends React.Component<IProps, IState> {
  state : IState = { }
  grid: Grid | null = null;
  componentDidMount = () => Index.getDerivedStateFromProps(this.props, this.state);
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.visible !== s?.visible) res.visible = p.visible;
    if (p?.entity !== s?.entity) res.entity = p.entity;
    if (p?.extraData !== s?.extraData) res.extraData = p.extraData;
    return res;
  }
  
  getData = (pag?: IPagination, sort?: string, filters?: any) : Promise<IPaginatedResponse<ImportacionDTO>> => API.importador().find({ 
    pageIndex: pag?.pageIndex, 
    pageSize: pag?.pageSize, 
    sort,
    entity: this.state.entity,
    extraDataJson: JSON.stringify(this.state.extraData ?? '{}')
  });

  doRollback = (row?: ImportacionDTO) => {
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    this.setState({ rollback: { loading: true }, question: undefined }, () => {
      API.importador().rollback({ id: row?.id })
        .then(res => {
          Alert.reponse(res);
          if (!!res.success && !!res.data) {
            const { rollback } = this.state;
            rollback!.loading = false;
            rollback!.result = res.data;
            this.setState({ rollback }, () => this.grid?.refresh());
          }
        }).catch(ex => {
          Alert.error(t("@Id#ErrorInesperado"), `${ex}`);
          this.setState({ rollback: undefined })
        })
    });
  }

  render() {
    const { visible, rollback } = this.state;
    const { onHide } = this.props;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    let order = 0;
    return <>
      <Loader loading={!!rollback?.loading}>
        <Dialog 
          visible={visible} onHide={onHide} dismissableMask 
          header={<><i className='fas fa-upload' /> {t("Title")}</>}
          style={{ width: '90%', height: '90%', minWidth: 350 }}
        >
          <GridComponent
            syncGrid={el => this.grid = el}
            data={this.getData}
            columns={[
              { order: ++order, field: 'creausulogin', header: t("Col.creausulogin"), sortable: true, filter: false },
              { order: ++order, field: 'creafecha', header: t("Col.creafecha"), sortable: true, filter: false, style:{ textAlign: 'center' }, body:row => <>{format(row.creafecha, 'dd/MM/yyyy HH:mm:ss')}</> },
              { order: ++order, field: 'scriptfecha', header: t("Col.scriptfecha"), sortable: true, filter: false, style:{ textAlign: 'center' }, body:row => <>{!!row.scriptfecha ? format(row.scriptfecha, 'dd/MM/yyyy HH:mm:ss') : ''}</> },
              { order: ++order, field: 'rollbackusulogin', header: t("Col.rollbackusulogin"), sortable: true, filter: false },
              { order: ++order, field: 'rollbackfecha', header: t("Col.rollbackfecha"), sortable: true, filter: false, style:{ textAlign: 'center' }, body:row => <>{!!row.rollbackfecha ? format(row.rollbackfecha, 'dd/MM/yyyy HH:mm:ss') : ''}</> },
            ]}
            columnCommandsWidth="50px"
            columnCommands={[
              { icon:"fas fa-reply", tooltip:t("Btn.Rollback"), onClick:row => this.setState({ question: row }), className:"p-button-rounded p-button-danger p-button-text", hide: row => !!row.rollbackfecha }
            ]}
          />
        </Dialog>
      </Loader>
      
      <Question 
        visible={!!this.state.question}
        title={t('Question.Title')}
        text={t('Question.Text', { creafecha: format(this.state.question?.creafecha, 'dd/MM/yyyy HH:mm'), creausulogin: this.state.question?.creausulogin })}
        ok_text={t("Question.Rollback")}
        ok_class={"p-button-danger"}
        cancel_text={t("Question.Cancel")}
        ok={() => this.doRollback(this.state.question)}
        onClose={() => this.setState({ question: undefined })}
      />
    </>;
  }
}

export const ImporterListado = connect((s:any) => ({ storage:s.main }))(Index);
